
    import axios from 'axios';
    import InfiniteLoading from 'vue-infinite-loading';
    import LoaderPopover from '@/components/loaderpopover_component.vue';
    export default 
    {
        // props: ['product_id', 'multi_book_id', 'show_upload_picture','title'],
        name: "productsImageMode",
        components: 
        {
        LoaderPopover,
        InfiniteLoading
        },   
        data: function () 
        {
            return {
                search_product:'',
                state:'',
                page_number:0,
                products_list:[],
				selected_products_list:[],
                search_data:false,
                show_products_loader:true,
                button2_label:'Update Products',
                on_page_load : true,
                products_exist : false,
				changes_done:false,
                timeout:null
            }
        },
        created(){
            this.get_products_list()
        },
		mounted(){
			if(this.$store.state.selected_products.length > 0){
				this.selected_products_list = JSON.parse(JSON.stringify(this.$store.state.selected_products));
			}
		},
        computed:{
			updated_products_list(){
				if(this.products_list){
					for(var first_index = 0;first_index < this.products_list.length;first_index++){
						for(var second_index = 0;second_index < this.selected_products_list.length;second_index++){
							if(this.products_list[first_index].product_id == this.selected_products_list[second_index].product_id){
								this.products_list[first_index].selected_quantity = this.selected_products_list[second_index].selected_quantity;
							}
						}
					}
				}
				return this.products_list;
			},
            button_label(){
                if(this.$store.state.selected_products.length > 0){
                    this.button2_label = 'Update Products';
                }
                else {
                    var count = '';
					if(this.selected_products_list.length) count = this.selected_products_list.length;
                    this.button2_label = `Add ${count} Products`;
                }     
                return this.button2_label;
            },
            disable_button(){
                var selected_product = true;
                if(this.button2_label != 'Update Products' && this.selected_products_list.length) selected_product = false;
				if(this.button2_label == 'Update Products' && this.changes_done) selected_product = false;
                return selected_product;
            }
            
        },
        methods: {
            get_products_list($state){
                this.state = $state;
                axios.post(this.$store.state.api +'v2/products/get_products_list_v2',{
                    "store_id":this.$session.get('store_id'),
                    "search_data":this.search_product,
                    "page_number":this.page_number
                }).then(response=>{
                    this.page_number++;
                    if(response.data.result.length) {

                        response.data.result.forEach(product => {
                            product.selected_quantity = 0
                            this.$store.state.selected_products.forEach(selected_product => {
                                if(selected_product.product_id == product.product_id)product.selected_quantity = selected_product.selected_quantity
                            });
                        });

                        this.products_exists_in_store = true;
                        this.page_number += 1;
                        if(this.search_data){
                            this.products_list = [];
                            this.search_data = false;
                        }
                        this.products_list.push(...response.data.result);
                        if($state){
                            $state.loaded()
                        }
                      } else {
                        $state.complete();
                        this.show_products_loader = false
                      }
                    if(this.on_page_load && response.data.result.length)this.products_exist = true;
                    this.on_page_load = false;
                });
            },
            get_products_by_keywords(){
                clearTimeout(this.timeout);
                this.timeout = setTimeout(()=>{
                    this.show_products_loader = true;
                    this.page_number = 0;
                    this.search_data = true;
                    this.get_products_list(this.state);
                    this.products_list = [];
                },900);                
            },
            change_quantity(index,status){
				this.changes_done = true;
				var product_alredy_exists = false;
				if(!this.selected_products_list.length){
					this.selected_products_list.push(this.products_list[index]);
					this.selected_products_list[0].selected_quantity = 1;
				}
				else{
					for(var selected_index = 0; selected_index < this.selected_products_list.length ; selected_index++){
							if(this.selected_products_list[selected_index].product_id == this.products_list[index].product_id){
								product_alredy_exists = true;
								if(status == 'add'){
									if(this.selected_products_list[selected_index].product_quantity > this.selected_products_list[selected_index].selected_quantity)
									{
										this.selected_products_list[selected_index].selected_quantity = this.selected_products_list[selected_index].selected_quantity + 1;
									}
								}
								else{
									if(this.selected_products_list[selected_index].selected_quantity > 0){
										this.selected_products_list[selected_index].selected_quantity = this.selected_products_list[selected_index].selected_quantity - 1;
									}
								}
							}
					}
					if(!product_alredy_exists){
						this.selected_products_list.push(this.products_list[index]);
						var required_index = this.selected_products_list.length-1;
						this.selected_products_list[required_index].selected_quantity = this.selected_products_list[required_index].selected_quantity + 1;
					}	
				}
            },
            update_products_list(){
                // this.$store.state.selected_products = [];
				// this.$store.state.selected_products = this.selected_products_list;
                var updated_selected_product_quantity = false;
                this.selected_products_list.forEach(product => {
                    updated_selected_product_quantity = false;
                    for(var index = 0;index < this.$store.state.selected_products.length; index++){
                        if(this.$store.state.selected_products[index].product_id == product.product_id){
                            updated_selected_product_quantity = true;
                            if(product.selected_quantity == 0) this.$store.state.selected_products.splice(index,1);
                            else {
                                this.$store.state.selected_products[index].selected_quantity = product.selected_quantity;
                                this.$store.state.selected_products[index].product_default_image.product_image_url = product.product_default_image.product_image_url;
                                this.$store.state.selected_products[index].product_default_image.product_thumbnail_url = product.product_default_image.product_thumbnail_url;
                            }
                        }
                    }
                    if(!updated_selected_product_quantity && product.selected_quantity) this.$store.state.selected_products.push(product);
                });
                this.$emit('close')
            },
            new_product(){
                this.$session.set('product_title','New Product');
                this.$session.set('came_from','newbooking');
                this.$session.set('has_products_in_page',true);
                this.$router.push('/product')
            },
    }
}
